//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmStripe from '~/components/atoms/Global/MdmStripe.vue';
export default {
  name: 'SpecialEventDecoration',
  components: {
    MdmStripe
  },
  props: {
    special: {
      type: Object,
      required: true
    },
    withAmount: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    schoolPredicate() {
      return this.special && this.special.is_school && this.special.is_school.is_enable;
    },

    formattedAmount() {
      return "".concat(this.$t('amount_donated', {
        x: this.special.is_school.amount
      }));
    },

    stripeAttrs() {
      let result = {
        text: null,
        amount: null,
        color: null
      };

      if (this.schoolPredicate) {
        result = {
          text: "".concat(this.$t('school')),
          amount: this.formattedAmount,
          color: '#A70074'
        };
      }

      return result;
    }

  }
};